import {ErrorMessage, Field} from 'formik';
import OTPInput from 'react-otp-input';
import {useCallback, useMemo, useState} from 'react';
import TermsModal from '../components/TermsModal';
import {useAuth} from '../service';

const IdentityStep = ({formik, onBack}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [otp, setOtp] = useState('');

  const {isPending: loadingCodeVerification, mutateAsync: verifyVerificationCode} =
    useAuth().verifyVerificationCode;

  const openTermsModal = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const closeTermsModal = () => {
    setIsModalOpen(false);
  };

  const acceptTerms = () => {
    formik.setFieldValue('termsAgreed', true);
    setIsModalOpen(false);
  };

  const handleCodeVerification = useCallback(async () => {
    console.log({formik});
    const data = {
      email: formik.values.email,
      code: otp,
    };
    await verifyVerificationCode(data).then((res) => {
      console.log(res);
      setIsVerified(true);
    });
  }, [formik, otp, verifyVerificationCode]);

  const identityForm = useMemo(
    () => (
      <div>
        <div className="row mb-1">
          <div className="col-6">
            <label className="form-label text-white-50 m-0" style={{fontSize: '10px'}}>
              First Name
            </label>
            <Field
              type="text"
              name="firstName"
              className="form-control gn-input-class text-white border-0 py-3"
              placeholder="First Name"
              style={{
                background: 'rgba(251, 251, 251, 0.1)',
              }}
            />
            <ErrorMessage
              name="firstName"
              component="div"
              className="text-danger"
              style={{fontSize: '10px'}}
            />
          </div>
          <div className="col-6">
            <label className="form-label text-white-50 m-0" style={{fontSize: '10px'}}>
              Middle Name (Optional)
            </label>
            <Field
              type="text"
              name="middleName"
              className="form-control gn-input-class text-white border-0 py-3"
              placeholder="First Name"
              style={{
                background: 'rgba(251, 251, 251, 0.1)',
              }}
            />
            <ErrorMessage
              name="middleName"
              component="div"
              className="text-danger"
              style={{fontSize: '10px'}}
            />
          </div>
        </div>

        <div className="mb-1">
          <label className="form-label text-white-50 m-0" style={{fontSize: '10px'}}>
            Last Name
          </label>
          <Field
            type="text"
            name="lastName"
            className="form-control gn-input-class text-white border-0 py-3"
            placeholder="Last Name"
            style={{
              background: 'rgba(251, 251, 251, 0.1)',
            }}
          />
          <ErrorMessage
            name="lastName"
            component="div"
            className="text-danger"
            style={{fontSize: '10px'}}
          />
        </div>

        <div className="mb-3">
          <label className="form-label text-white-50 m-0" style={{fontSize: '10px'}}>
            Date of Birth
          </label>
          <Field
            type="text"
            name="dob"
            className="form-control gn-input-class text-white border-0 py-3"
            placeholder="12-27-1995"
            style={{
              background: 'rgba(251, 251, 251, 0.1)',
            }}
          />
          <ErrorMessage
            name="dob"
            component="div"
            className="text-danger"
            style={{fontSize: '10px'}}
          />
        </div>

        <div className="mb-3">
          <label className="form-label text-white-50 m-0" style={{fontSize: '10px'}}>
            Password
          </label>
          <Field
            type="password"
            name="password"
            className="form-control gn-input-class text-white border-0 py-3"
            placeholder="**********"
            style={{
              background: 'rgba(251, 251, 251, 0.1)',
            }}
          />
          <ErrorMessage
            name="password"
            component="div"
            className="text-danger"
            style={{fontSize: '10px'}}
          />
        </div>

        <div className="form-check mb-3">
          <Field type="checkbox" name="termsAgreed" className="form-check-input" id="termsAgreed" />
          <p
            className="form-check-label text-white-50 m-0"
            htmlFor="termsAgreed"
            style={{fontSize: '10px', lineHeight: '15px'}}
          >
            I have read, understood, and agree to the{' '}
            <a href="#" className="text-primary" onClick={openTermsModal}>
              Terms and Conditions
            </a>
          </p>
          <ErrorMessage
            name="termsAgreed"
            component="div"
            className="text-danger"
            style={{fontSize: '10px'}}
          />
        </div>

        <div className="d-flex gap-2">
          <button
            type="submit"
            className="btn btn-primary w-100 py-3"
            style={{
              backgroundColor: '#2E2CB2',
              border: 'none',
              fontSize: '13px',
            }}
            disabled={formik.isSubmitting}
          >
            {formik.isSubmitting ? <div className="loader" /> : 'Submit'}
          </button>
        </div>
      </div>
    ),
    [formik.isSubmitting],
  );

  const verificationForm = useMemo(
    () => (
      <div>
        <div className="row mb-[26px]">
          <div className="col-12">
            <label className="form-label text-white-50 mb-[27px]" style={{fontSize: '10px'}}>
              Enter the 6-digit code we sent to your email
            </label>
            <OTPInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              renderInput={(props) => (
                <div className="flex-1">
                  <input
                    {...props}
                    style={{width: '100%'}}
                    className="gn-input-class text-white text-center border-0 h-[47px] w-full rounded-md bg-[#fbfbfb1a]"
                  />
                </div>
              )}
              containerStyle={{
                justifyContent: 'center',
                gap: 8,
              }}
            />
          </div>
        </div>

        <div className="d-flex gap-2">
          <button
            type="button"
            className="btn btn-primary w-100 py-3"
            style={{
              backgroundColor: '#2E2CB2',
              border: 'none',
              fontSize: '13px',
            }}
            disabled={loadingCodeVerification || otp.length < 6}
            onClick={handleCodeVerification}
          >
            {loadingCodeVerification ? <div className="loader" /> : 'Verify'}
          </button>
        </div>
      </div>
    ),
    [handleCodeVerification, loadingCodeVerification, otp],
  );

  return (
    <div className="registration-form">
      {/* <TermsModal
                isOpen={isModalOpen}
                onClose={closeTermsModal}
                onAccept={acceptTerms}
            /> */}

      <h2 className="text-white mb-4" style={{fontSize: '20px'}}>
        Verify Your Identity
      </h2>
      {isVerified ? identityForm : verificationForm}
    </div>
  );
};

export default IdentityStep;
